import React from 'react';
import { useThemeStore } from '../../state/theme';

interface TagInputProps {
  placeholder?: string;
  inputClassName?: string;
  onEnter?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  tags?: string[];
  onRemoveTag?: (index: number) => void;
}

const TagInput: React.FC<TagInputProps> = ({
  placeholder = 'Add tag and press Enter',
  inputClassName,
  onEnter,
  tags = [],
  onRemoveTag,
}) => {
  const { isDarkMode } = useThemeStore();

  const defaultInputClassName = `w-full rounded-md px-3 py-2 shadow-sm focus:outline-none ${
    isDarkMode
      ? 'bg-gray-700 border-gray-600 text-gray-100 focus:border-indigo-500 focus:ring-indigo-500'
      : 'border border-gray-300 focus:border-indigo-500 focus:ring-indigo-500'
  }`;

  return (
    <div className="flex flex-wrap gap-2">
      <input
        type="text"
        placeholder={placeholder}
        className={inputClassName || defaultInputClassName}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            onEnter?.(e);
          }
        }}
      />
      <div className="flex flex-wrap gap-2 mt-2">
        {tags?.map((tag: string, index: number) => (
          <span
            key={index}
            className={`px-2 py-1 rounded-md flex items-center gap-2 ${
              isDarkMode
                ? 'bg-gray-700 text-gray-200'
                : 'bg-gray-200 text-gray-800'
            }`}
          >
            {tag}
            <button
              type="button"
              onClick={() => onRemoveTag?.(index)}
              className={`hover:text-red-500 transition-colors ${
                isDarkMode ? 'text-gray-300' : 'text-gray-600'
              }`}
            >
              ×
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default TagInput;
